// src/pages/BookingSuccess.jsx

import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function BookingSuccess() {
  const [searchParams] = useSearchParams();
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  const transaction_id = searchParams.get("transaction_id");

  useEffect(() => {
    const verifyPayment = async () => {
      if (!transaction_id) {
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `https://creator-mvp-hvdx.onrender.com/booking/verify?transaction_id=${transaction_id}`
        );

        const data = await res.json();

        console.log("VERIFY RESPONSE:", data);

        if (data.status === "success") {
          setVerified(true);
        }
      } catch (err) {
        console.error("Verification error:", err);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [transaction_id]);

  // ⏳ Loading
  if (loading) {
    return (
      <h2 style={{ textAlign: "center", marginTop: 50 }}>
        Verifying payment... ⏳
      </h2>
    );
  }

  // ❌ NOT verified (ONLY backend decides)
  if (!verified) {
    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <h1>⏳ Payment pending verification</h1>
        <p>
          If you completed payment, please wait a few seconds and refresh.
        </p>
      </div>
    );
  }

  // ✅ SUCCESS
  return (
    <div style={{ textAlign: "center", padding: 40 }}>
      <h1>✅ Payment Successful</h1>
      <p>Your slot is now secured.</p>
      <p>Please choose your session time below:</p>

      <iframe
        title="Creator Yard Booking"
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3QZ89Ri983CkzBj42--uI10tHlLBKOjeggbbCm6Y5kNDnVnCX3dSVUkVLGusnb9hqA3FOP6XTK?gv=true"
        style={{
          border: 0,
          width: "100%",
          height: "650px",
          marginTop: 20,
        }}
      />
    </div>
  );
}